import React, { FC } from 'react';
import classNames from 'classnames';
import { IReserveComputation } from '@shared/api';
import './General.scss';

interface IReserveComputationInfoProps {
    fieldName: string;
    value: string | number | boolean;
    Icon?: React.FC;
    className?: string;
}

const ReserveComputationInfo: FC<IReserveComputationInfoProps> = (props) => {
    const { fieldName, value, Icon, className } = props;

    return (
        <div className={classNames('reserve-computation-general-info__info-item', className)}>
            <span className='reserve-computation-general-info__info-header'>{fieldName}:</span>
            <span className={classNames('reserve-computation-general-info__info-content', value, { nullable: !value })}>
                {Icon && <Icon />} {value}
            </span>
        </div>
    );
};

interface IGeneralProps {
    data: IReserveComputation;
}

export const General: React.FC<IGeneralProps> = ({ data }) => {
    return (
        <div className='reserve-computation-general-info'>
            <ReserveComputationInfo
                fieldName={'Initial Balance'}
                value={data.initialBalance}
            />
            <ReserveComputationInfo
                fieldName={'Deposits'}
                value={data.deposits}
            />
            <ReserveComputationInfo
                fieldName={'Withdrawals'}
                value={data.withdrawals}
            />
            <ReserveComputationInfo
                fieldName={'Pending Withdrawals'}
                value={data.pendingWithdrawals}
            />
            <ReserveComputationInfo
                fieldName={'Cust Credits GLC Clearing'}
                value={data.custCreditsGLClearing}
            />
            <ReserveComputationInfo
                fieldName={'Cust Credits GL Reports'}
                value={data.custCreditsGLReports}
            />
            <ReserveComputationInfo
                fieldName={'Final Balance'}
                value={data.finalBalance}
            />
            <ReserveComputationInfo
                fieldName={'Total Excess'}
                value={data.totalExcess}
            />
            <ReserveComputationInfo
                fieldName={'Total Liability'}
                value={data.totalLiability}
            />
        </div>
    );
};
